import { createContext } from "react";
import dataStore from "../Store/dataStore";

export const dataContext = createContext(dataStore);